import React from 'react'
import type { IAlarm } from '@obvious.tech/constellation'

import { AlarmProvider } from 'src/parser/shared/PDF/Provider'
import type { TAlarmReportProps } from 'src/parser/shared/PDF/Provider'
import type { TEntity } from 'src/utils/api'

import { offscreenHost } from './offscreenHost'

export type TAlarmReportCollectorProps = {
  entity: TEntity<IAlarm>
  authorization?: string
  onReady: (report: TAlarmReportProps) => void
}

const Leaf = (
  props: {
    onReady: (report: TAlarmReportProps) => void
  } & Partial<TAlarmReportProps>,
): null => {
  const { onReady, ...report } = props
  const reportedRef = React.useRef(false)

  React.useEffect(() => {
    if (reportedRef.current) return
    if (report.entity === undefined) return

    reportedRef.current = true
    onReady(report as TAlarmReportProps)
  }, [onReady, report])

  return null
}

const AlarmReportCollector = ({
  entity,
  authorization,
  onReady,
}: TAlarmReportCollectorProps): JSX.Element => (
  <div
    style={offscreenHost}
    aria-hidden
  >
    <AlarmProvider
      entity={entity}
      authorization={authorization}
    >
      <Leaf onReady={onReady} />
    </AlarmProvider>
  </div>
)

export default AlarmReportCollector
